export function frontendBasePath(frontendUrl: string): string {
  const path = new URL(frontendUrl).pathname.replace(/\/+$/, "");
  return path || "/";
}

function configuredFrontendUrl(): string {
  return import.meta.env.VITE_APP_URL || window.location.origin;
}

export function configuredFrontendBasePath(): string {
  return frontendBasePath(configuredFrontendUrl());
}

export function configuredFrontendPath(path: string): string {
  const basePath = configuredFrontendBasePath();
  if (basePath === "/") return path;
  const prefixBoundary = path.charAt(basePath.length);
  if (
    path.startsWith(basePath) &&
    (prefixBoundary === "" || ["/", "?", "#"].includes(prefixBoundary))
  )
    return path;
  return `${basePath}${path}`;
}
